import * as React from 'react';

import {Button} from 'shells/button/button';
import {ErrorState} from 'shells/error-state/error-state';
import {FooterBar} from 'shells/modal/footer-bar';

import type {GetWebFormStarters_webFormStarters as FormStarter} from 'nutshell-graphql-types';

import {FormStartersGrid} from './form-starters-grid';

type Props = {
    formStarters: FormStarter[];
    isSaving: boolean;
    isLoading: boolean;
    onCloseModal: () => void;
    onCreateForm: (name: string, starterId?: string) => Promise<any>;
    error?: string | null | undefined;
};

export function NewFormForm(props: Props) {
    return (
        <div className='flex justify-sb flex-dir-col full-height'>
            <FormStartersGrid
                isLoading={props.isLoading}
                formStarters={props.formStarters}
                onStartFromScratch={() => {
                    props.onCreateForm('Untitled form');
                }}
                setSelectedStarterFormId={(selectedStarterFormId) => {
                    const selectedFormStarter = props.formStarters.find((form) => {
                        return form.id === selectedStarterFormId;
                    });

                    const newFormInitialName = selectedFormStarter
                        ? `Copy of ${selectedFormStarter.name}`
                        : 'Untitled form';

                    props.onCreateForm(newFormInitialName);
                }}
                // @ts-expect-error
                onCloseModal={props.onCloseModal}
            />
            {props.error ? <ErrorState errorMessage={props.error} /> : undefined}
            <FooterBar
                right={
                    <Button
                        type='button'
                        variant='text-primary'
                        size='big'
                        onClick={() => {
                            props.onCreateForm('Untitled form');
                        }}
                    >
                        {props.isSaving ? 'Creating…' : 'Start from scratch'}
                    </Button>
                }
            />
        </div>
    );
}
